
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import { MembershipFormData } from "../types";

interface TermsAcceptanceProps {
  form: UseFormReturn<MembershipFormData>;
}

export const TermsAcceptance = ({ form }: TermsAcceptanceProps) => {
  return (
    <FormField
      control={form.control}
      name="termsAccepted"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel>
              I hereby make application to be admitted as a Member of the Seed Potato Organisation Ltd. I agree to purchase one thousand shares at £1 per share which I understand to be neither transferable nor withdrawable. On receipt of this application, you will be sent an invoice with details for payment. I undertake, if admitted, to be bound by the Rules of the Co-op as well as the Seed Potato Organisation Ltd. Code of Conduct.
            </FormLabel>
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
};
